<template>
  <rpm-modal :open="open" header="Editar procedimento">
    <section class="grid grid-cols-12 gap-x-4 gap-y-6">
      <rpm-input
          class="col-span-4"
          type="datetime-local"
          v-model="form.executed_at"
          label="Data de Execução"
          :errors="errors.executed_at"
          placeholder="Data de Execução"
      ></rpm-input>

      <rpm-input
          class="col-span-4"
          type="select"
          :options="collaborators"
          v-model="form.executor_id"
          optionValue="userid"
          optionLabel="name"
          label="Executor"
          :errors="errors.executor_id"
          placeholder="Executor"
      ></rpm-input>

      <rpm-input
          class="col-span-4"
          type="select"
          :options="sourceProcedureSituations"
          v-model="form.source_procedure_situation_id"
          optionValue="id"
          optionLabel="description"
          label="Situação"
          :errors="errors.source_procedure_situation_id"
          placeholder="Situação"
      ></rpm-input>
      <rpm-input
          class="col-span-4"
          type="select"
          :options="organizationsBySourceSituation"
          v-model="form.next_organization_id"
          optionValue="organization_id"
          optionLabel="organization_name"
          label="Próxima organização"
          :errors="errors.next_organization_id"
          placeholder="Próxima organização"
          v-if="organizationsBySourceSituation.length"
      ></rpm-input>
      <rpm-input
          class="col-span-4"
          type="select"
          :options="nextProcedureOwners"
          v-model="form.next_owner_id"
          optionValue="id"
          optionLabel="name"
          :label="next_owner_required ? 'Responsável pelo próximo procedimento *' : 'Responsável pelo próximo procedimento'"
          :errors="errors.next_owner_id"
          placeholder="Responsável"
          v-if="nextProcedureOwners"
      ></rpm-input>

      <rpm-input
          v-if="observation_required"
          class="col-span-12"
          type="editor"
          v-model="form.observation"
          label="Observação"
          :errors="errors.observation"
          placeholder="Observação"
      ></rpm-input>

    </section>
    <section class="flex flex-row justify-center gap-6 mt-4">
      <rpm-button @click="save" label="Salvar"/>
      <rpm-button @click="this.$emit('close')" label="Fechar" color="gray"/>
    </section>
  </rpm-modal>
</template>

<script>
import {ref, reactive, toRef} from 'vue'
import moment from "moment/moment";
import _ from "lodash";

import procedureRepository from "#repositories/procedureRepository";
import sourceProcedureSituationStore from '#repositories/sourceProcedureSituationRepository.js'
import {getErrors} from "#functions/validator";
import collaboratorRepository from "#repositories/collaboratorRepository";
import RpmModal from "#components/RpmModal.vue";

export default {
  name: 'EditProcedureExecution',
  components: {
    RpmModal
  },
  props: {
    procedure: {
      type: Object,
      required: true
    },
    open: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      errors: {},
      collaborators: [],
      form: {},
      observation_required: false,
      sourceProcedureSituations: [],
      organizationsBySourceSituation: [],
      nextProcedureOwners: null,
      next_owner_required: false,
      next_source_procedure: null,
      sourceProcedureOrganization: []
    };
  },
  methods: {
    async listCollaboratorsByOrganization() {

      if (this.procedure.organizations) {

        collaboratorRepository.listCollaboratorsByOrganization(this.currentOrganization()).then((response) => {
          this.collaborators = response.data
          this.form.executor_id = this.procedure.executor.id
        })

      }

    },
    currentOrganization() {
      return this.$user.person.collaborator.organization.id;
    },
    getSourceServiceSituations() {
      sourceProcedureSituationStore.getSourceProcedureSituations(this.procedure.source_procedure.id).then((response) => {
        this.sourceProcedureSituations = []
        response.data.forEach((element) => {
          if (element.enabled) {
            this.sourceProcedureSituations.push({
              id: element.id,
              description: element.source_situation.description,
              observation_required: element.observation_required,
              next_source_procedure: element.next_source_procedure
            });
          }
        })
      }).then(() => {
        this.form.source_procedure_situation_id = this.procedure.situations[0].sourceProcedureSituation.id
      })
    },
    async executeProcedure() {
      if (!this.form.current_organization_id) {
        this.form.current_organization_id = this.currentOrganization()
      }

      procedureRepository.updateProcedure(this.procedure.id, this.form).then((response) => {
        this.$notify('Procedimento Executado', 'success');
        this.$emit('procedureExecuted', response.data);
      }).catch((response) => {
        this.$notify('Erro ao executar procedimento', 'error');
        getErrors(this.errors, response.errors);
      });
    },
    save() {
      procedureRepository.updateProcedureExecution(this.procedure.id, this.form).then((response) => {
        this.$notify(response.message, 'success')
        this.$emit('edited')
      }).catch((error) => {
        this.$notify(error.message, 'error')
      })
    }

  },
  mounted() {
    this.listCollaboratorsByOrganization();
    this.getSourceServiceSituations();
    this.form = {
      executed_at: moment(this.procedure.executed_at).format('YYYY-MM-DD HH:mm'),
      observation: this.procedure.observation,
      executor_id: this.procedure.executor_id,
      next_organization_id: '',
      next_owner_id: null,
      owner_id: this.procedure.owner_id,
    }

  },
  watch: {
    async 'form.source_procedure_situation_id'(val) {

      let situation = _.find(this.sourceProcedureSituations, (element) => {
        return element.id === val
      })
      this.observation_required = situation.observation_required

      let nextSourceProcedureBySituation = _.find(this.sourceProcedureSituations, {'id': val})

      const nextSourceProcedure = nextSourceProcedureBySituation.next_source_procedure
      const requiredOwnerOrganizations = nextSourceProcedure?.required_owner_organizations ?? []

      this.next_owner_required = requiredOwnerOrganizations.length > 0
      this.form.next_owner_id = null
      this.nextProcedureOwners = null

      if (nextSourceProcedure) {
        collaboratorRepository.listByOrganizations(val).then((response) => {
          this.nextProcedureOwners = response.data.length > 0 ? response.data : null
        })
      }
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
